import { render, staticRenderFns } from "./ResultSmall.vue?vue&type=template&id=4cd6ed0a&scoped=true&lang=pug"
import script from "./ResultSmall.vue?vue&type=script&lang=js"
export * from "./ResultSmall.vue?vue&type=script&lang=js"
import style0 from "./ResultSmall.vue?vue&type=style&index=0&id=4cd6ed0a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6ed0a",
  null
  
)

export default component.exports